<template>
    <b-form-group
        :label="fieldLabel"
        :labelClass="labelClass"
        label-for="status"
    >
        <template slot="label">
            <slot name="label">
                <span>
                    {{ fieldLabel }}
                </span>
            </slot>
        </template>
        <multiselect-color
            id="statusSelect"
            :state="state"
            :options="options"
            :loading="isLoading"
            :selected="selected"
            :multiple="multiple"
            :placeholder="placeholder"
            :closeOnSelect="closeOnSelect"
            @click="getStatus"
            @changeValue="changed($event)"
        />
        <template slot="invalid-feedback">
            <b-form-invalid-feedback style="font-size: 11px" :state="state">
                <slot name="invalid-feedback"></slot>
            </b-form-invalid-feedback>
        </template>
    </b-form-group>
</template>

<script>
import i18n from '@/i18n'
import { cloneDeep } from 'lodash'
import { getAllStatus } from './api'
import mapperToOptions from './mapperToOptions'
import { MultiselectColor } from '@/views/components/selects'
export default {
    name: 'Status',
    components: {
        MultiselectColor,
    },
    props: {
        label: String,
        placeholder: String,
        setDefaultStatus: Boolean,
        selected: [Object, Array],
        labelClass: [Array, Object, String],
        state: {
            type: Boolean,
            default: null,
        },
        lazyLoading: {
            default: false,
            type: Boolean,
        },
        multiple: {
            default: true,
            type: Boolean,
        },
        closeOnSelect: {
            type: Boolean,
            default: true,
        },
        except: {
            default: '',
            type: String,
        },
    },
    data() {
        return {
            options: [],
            isLoaded: false,
            isLoading: false,
        }
    },
    computed: {
        fieldLabel() {
            return this.label ? this.label : i18n.t('people.status')
        },
    },
    mounted() {
        if (!this.lazyLoading) {
            this.getStatus()
        }
    },
    methods: {
        getStatus() {
            if (this.isLoaded) {
                return
            }

            this.isLoading = true
            getAllStatus(this.except)
                .then(res => {
                    this.mapOptions(res)
                    this.handleDefaultStatus()
                    this.$emit('options-loaded', this.options)
                    this.$store.dispatch('filterStatus', this.options)
                })
                .finally(() => {
                    this.$emit('ready', true)
                    this.isLoading = false
                    this.isLoaded = true
                })
        },
        mapOptions(status) {
            this.options = mapperToOptions(status)
        },
        handleDefaultStatus() {
            if (!this.setDefaultStatus) {
                return
            }

            const defaultOption = this.options.filter(
                i => i.label == i18n.t('status.active.name')
            )
            this.changed(defaultOption)
        },
        changed(event) {
            this.$emit('update:selected', event)
            this.$emit('change')
        },
        clone(arr) {
            return cloneDeep(arr)
        },
    },
}
</script>
